import * as React from 'react';
import { Accordion, AccordionItem } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { VoucherCodeFormContainer } from './VoucherCodeForm/VoucherCodeFormContainer.js';

const VoucherCodesLayout = ({ cartId  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(Accordion, {
        className: "cart-footer__acc"
    }, /*#__PURE__*/ React.createElement(AccordionItem, {
        id: "discount-code",
        className: "cart-footer__acc__item",
        label: getLabel('cart.discountForm.title'),
        headingLevel: "h4"
    }, /*#__PURE__*/ React.createElement(VoucherCodeFormContainer, {
        className: "cart-footer__acc__form",
        cartId: cartId,
        inputId: "discount-code"
    })));
};

export { VoucherCodesLayout };
//# sourceMappingURL=VoucherCodesLayout.js.map
